import { Box, Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const ContactConsultantButton = () => {
   return (
      <Button
         href="https://calendar.app.google/KcrgoEnbz9SJScGv8"
         target={"_blank"}
         sx={{
            zIndex: 10,
            mt: "-20px",
            borderRadius: 3,
            p: 1.5,
            bgcolor: "#4778A5",
            "&:hover": { bgcolor: "#3d6890" },
         }}
      >
         <Box sx={{ display: "flex", alignItems: "center" }} mx={1}>
            <Typography fontWeight={"bold"} lineHeight={1.2}>
               Contactar a un consultor
            </Typography>
            <ArrowForwardIcon fontSize={"small"} sx={{ ml: 0.5 }} />
         </Box>
      </Button>
   );
};

export default ContactConsultantButton;
